import React, { useEffect, useState } from 'react';
import { XCircle } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext.tsx';
import { marcarNoShowAgendamento } from '../../services/api.ts';
import BaseModal from './_BaseModal.tsx';
import { getAuth } from './_helpers.ts';

interface NoShowModalProps {
  isOpen: boolean;
  onClose: () => void;
  agendamentoId: number | null | undefined;
  clinicId: number;
  onMarked?: () => void;
}

const NoShowModal: React.FC<NoShowModalProps> = ({
  isOpen,
  onClose,
  agendamentoId,
  clinicId,
  onMarked,
}) => {
  const { isDark } = useTheme();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [observacao, setObservacao] = useState('');

  useEffect(() => {
    if (isOpen) {
      setObservacao('');
      setError(null);
    }
  }, [isOpen]);

  const isMissingId = !agendamentoId;

  const handleSubmit = async () => {
    if (!agendamentoId) return;
    setSaving(true);
    setError(null);
    try {
      const auth = getAuth(clinicId);
      console.log('[NoShowModal] Marcando no-show', { agendamentoId, observacao });
      await marcarNoShowAgendamento(auth.clientId, auth.clinicId, agendamentoId, {
        observacao,
      });
      console.log('[NoShowModal] No-show registrado');
      onMarked?.();
      onClose();
    } catch (err: any) {
      console.error('[NoShowModal] Erro:', err);
      setError(err?.response?.data?.detail || err?.message || 'Erro ao registrar falta');
    } finally {
      setSaving(false);
    }
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Marcar falta"
      subtitle="Registrar que o lead não compareceu"
      icon={XCircle}
      primaryLabel="Marcar como falta"
      onPrimary={isMissingId ? undefined : handleSubmit}
      saving={saving}
      error={error}
    >
      {isMissingId ? (
        <p className={`text-sm ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
          Este contato não tem agendamento ativo para marcar falta.
        </p>
      ) : (
        <div className="space-y-2">
          <label className={`block text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
            Observação (opcional)
          </label>
          <textarea
            value={observacao}
            onChange={(e) => setObservacao(e.target.value)}
            rows={4}
            placeholder="Motivo, contexto ou detalhes da falta..."
            autoFocus
            className={`w-full p-3 border rounded-xl text-sm resize-none focus:ring-2 focus:ring-sminy-primary focus:border-sminy-primary transition-colors ${
              isDark
                ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400'
                : 'bg-white border-gray-300 text-gray-900 placeholder-gray-400'
            }`}
          />
        </div>
      )}
    </BaseModal>
  );
};

export default NoShowModal;
